"use client";

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { Card } from '@/components/ui/Card';
import { Users, Target, Award, TrendingUp, Shield, Clock, CheckCircle, ArrowRight } from 'lucide-react';
export default function ForCompanies() {
  const $ = _c(41);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      threshold: 0.2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    ref,
    isVisible
  } = useScrollAnimation(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      icon: Users,
      title: "Pre-Vetted Talent Pool",
      description: "Access 10,000+ students with verified skills and completed certifications"
    }, {
      icon: Target,
      title: "Smart Matching",
      description: "AI-powered matching connects you with candidates that fit your exact requirements"
    }, {
      icon: Award,
      title: "Skill Verification",
      description: "Every candidate comes with verified certificates and leaderboard rankings"
    }, {
      icon: Clock,
      title: "Save Time & Money",
      description: "Reduce hiring time by 70% and cut recruitment costs significantly"
    }, {
      icon: Shield,
      title: "Quality Assurance",
      description: "Report performance issues and we'll help improve or replace candidates"
    }, {
      icon: TrendingUp,
      title: "Grow Your Team",
      description: "Scale your workforce with interns and junior developers ready to contribute"
    }];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const benefits = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [{
      number: "500+",
      label: "Partner Companies"
    }, {
      number: "95%",
      label: "Retention Rate"
    }, {
      number: "3 Days",
      label: "Average Hire Time"
    }, {
      number: "70%",
      label: "Cost Reduction"
    }];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const stats = t2;
  const t3 = ref as React.RefObject<HTMLElement>;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0,
      y: 20
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isVisible) {
    t5 = isVisible ? {
      opacity: 1,
      y: 0
    } : {};
    $[4] = isVisible;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      duration: 0.6
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-semibold mb-4"><Users className="w-4 h-4" /><span>For Hiring Managers</span></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Hire Top Talent<span className="block bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">{"Faster & Smarter"}</span></h2>;
    t9 = <p className="text-xl text-gray-600 max-w-3xl mx-auto">Stop wasting time on unqualified applicants. Get matched with skilled, verified candidates ready to work.</p>;
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t5) {
    t10 = <motion.div initial={t4} animate={t5} transition={t6} className="text-center mb-16">{t7}{t8}{t9}</motion.div>;
    $[10] = t5;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== isVisible) {
    t11 = <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">{benefits.map((benefit, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: index * 0.1
      }}><Card className="h-full"><div className="p-6"><div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center mb-4"><benefit.icon className="w-6 h-6 text-[#6059f7]" /></div><h3 className="text-lg font-bold text-gray-900 mb-2">{benefit.title}</h3><p className="text-gray-600">{benefit.description}</p></div></Card></motion.div>)}</div>;
    $[12] = isVisible;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      opacity: 0,
      y: 20
    };
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== isVisible) {
    t13 = isVisible ? {
      opacity: 1,
      y: 0
    } : {};
    $[15] = isVisible;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      duration: 0.6,
      delay: 0.6
    };
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = stats.map(_temp);
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== t13) {
    t16 = <motion.div initial={t12} animate={t13} transition={t14} className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">{t15}</motion.div>;
    $[19] = t13;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      opacity: 0,
      y: 20
    };
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== isVisible) {
    t18 = isVisible ? {
      opacity: 1,
      y: 0
    } : {};
    $[22] = isVisible;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      duration: 0.6,
      delay: 0.8
    };
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  let t21;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <h3 className="text-3xl font-bold mb-4">Start Hiring Today</h3>;
    t21 = <p className="text-blue-100 mb-6">Join 500+ companies already hiring verified talent through our platform. Post your first opportunity for free.</p>;
    $[25] = t20;
    $[26] = t21;
  } else {
    t20 = $[25];
    t21 = $[26];
  }
  let t22;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <li className="flex items-center gap-3"><CheckCircle className="w-5 h-5" /><span>No upfront costs or subscriptions</span></li>;
    $[27] = t22;
  } else {
    t22 = $[27];
  }
  let t23;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <li className="flex items-center gap-3"><CheckCircle className="w-5 h-5" /><span>Only pay when you hire</span></li>;
    $[28] = t23;
  } else {
    t23 = $[28];
  }
  let t24;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div>{t20}{t21}<ul className="space-y-3 mb-6">{t22}{t23}<li className="flex items-center gap-3"><CheckCircle className="w-5 h-5" /><span>Cancel anytime, no commitments</span></li></ul></div>;
    $[29] = t24;
  } else {
    t24 = $[29];
  }
  let t25;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="grid md:grid-cols-2 gap-8 items-center">{t24}<div className="flex flex-col gap-4"><button className="px-8 py-4 bg-white text-[#6059f7] rounded-lg font-semibold hover:bg-gray-100 transition-colors shadow-xl flex items-center justify-center gap-2 group">Post a Job Opening<ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" /></button><button className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg font-semibold hover:bg-white/10 transition-colors">Schedule a Demo</button></div></div>;
    $[30] = t25;
  } else {
    t25 = $[30];
  }
  let t26;
  if ($[31] !== t18) {
    t26 = <motion.div initial={t17} animate={t18} transition={t19} className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl p-8 md:p-12 text-white">{t25}</motion.div>;
    $[31] = t18;
    $[32] = t26;
  } else {
    t26 = $[32];
  }
  let t27;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t16 || $[36] !== t26) {
    t27 = <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{t10}{t11}{t16}{t26}</div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t16;
    $[36] = t26;
    $[37] = t27;
  } else {
    t27 = $[37];
  }
  let t28;
  if ($[38] !== t27 || $[39] !== t3) {
    t28 = <section id="for-companies" className="py-20 md:py-32 bg-white" ref={t3}>{t27}</section>;
    $[38] = t27;
    $[39] = t3;
    $[40] = t28;
  } else {
    t28 = $[40];
  }
  return t28;
}
function _temp(stat, index_0) {
  return <div key={index_0} className="text-center"><div className="text-4xl font-bold text-[#6059f7] mb-2">{stat.number}</div><div className="text-gray-600">{stat.label}</div></div>;
}